import React from 'react';
import {
  FiHome,
  FiPieChart,
  FiUserPlus,
  FiUsers,
  FiFileText,
  FiHelpCircle,
  FiShield,
  FiInbox,
  FiUserCheck,
  FiActivity,
  FiArchive,
} from 'react-icons/fi';

// Default items, visible to every authenticated user.
const DEFAULT_ITEMS = [
  { title: 'Home', path: '/home', icon: <FiHome size={20} /> },
  { title: 'Dashboard', path: '/dashboard', icon: <FiPieChart size={20} /> },
  { title: 'Add New Child', path: '/add-child', icon: <FiUserPlus size={20} /> },
  { title: 'Profiles', path: '/profiles', icon: <FiUsers size={20} /> },
  { title: 'Reports', path: '/reports', icon: <FiFileText size={20} /> },
  { title: 'Vaccine Catalogue', path: '/vaccination', icon: <FiActivity size={20} /> },
  { title: 'Help', path: '/help', icon: <FiHelpCircle size={20} /> },
];

// Admin-only items. Rendered below a divider when the signed-in user
// has role === "admin".
const ADMIN_ITEMS = [
  { title: 'Admin Dashboard', path: '/admin', icon: <FiShield size={20} /> },
  { title: 'Help Messages', path: '/admin/messages', icon: <FiInbox size={20} /> },
  { title: 'Users', path: '/admin/users', icon: <FiUserCheck size={20} /> },
  { title: 'Archived Profiles', path: '/profiles/archived', icon: <FiArchive size={20} /> },
];

/**
 * Resolve the sidebar entries for a given role.
 * @param {"admin"|"user"|"staff"|null|undefined} role
 * @returns {{items: Array, adminDivider: boolean}}
 */
export function getSideBarEntries(role) {
  if (role === 'admin') {
    return { items: [...DEFAULT_ITEMS, ...ADMIN_ITEMS], adminDivider: true };
  }
  return { items: DEFAULT_ITEMS, adminDivider: false };
}

// Backwards-compatible export for any callers still importing the
// static array (e.g. tests). It contains only the default items.
export const SideBarData = DEFAULT_ITEMS;